import type { IconProps } from '../types/icons';

export default function WorldIconFilled({
  width = 40,
  height = 40,
  fill = 'black',
  className,
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="flag" clipPath="url(#clip0_4819_160)">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.0390625 0.0390625H39.9609V39.9609H0.0390625V0.0390625Z"
          fill="#1E433D"
        />
        <path
          id="Vector_2"
          d="M27.8665 27.1865C27.5198 26.1198 26.5198 25.3332 25.3332 25.3332H23.9998V21.3332C23.9998 20.9795 23.8594 20.6404 23.6093 20.3904C23.3593 20.1403 23.0201 19.9998 22.6665 19.9998H14.6665V17.3332H17.3332C17.6868 17.3332 18.0259 17.1927 18.276 16.9426C18.526 16.6926 18.6665 16.3535 18.6665 15.9998V13.3332H21.3332C22.0404 13.3332 22.7187 13.0522 23.2188 12.5521C23.7189 12.052 23.9998 11.3737 23.9998 10.6665V10.1198C27.9065 11.6932 30.6665 15.5198 30.6665 19.9998C30.6665 22.7732 29.5998 25.2932 27.8665 27.1865ZM18.6665 30.5732C13.3998 29.9198 9.33317 25.4398 9.33317 19.9998C9.33317 19.1732 9.43984 18.3732 9.61317 17.6132L15.9998 23.9998V25.3332C15.9998 26.0404 16.2808 26.7187 16.7809 27.2188C17.281 27.7189 17.9593 27.9998 18.6665 27.9998M19.9998 6.6665C18.2489 6.6665 16.5151 7.01138 14.8974 7.68144C13.2797 8.35151 11.8099 9.33363 10.5717 10.5717C8.07126 13.0722 6.6665 16.4636 6.6665 19.9998C6.6665 23.5361 8.07126 26.9274 10.5717 29.4279C11.8099 30.666 13.2797 31.6482 14.8974 32.3182C16.5151 32.9883 18.2489 33.3332 19.9998 33.3332C23.5361 33.3332 26.9274 31.9284 29.4279 29.4279C31.9284 26.9274 33.3332 23.5361 33.3332 19.9998C33.3332 18.2489 32.9883 16.5151 32.3182 14.8974C31.6482 13.2797 30.666 11.8099 29.4279 10.5717C28.1898 9.33363 26.72 8.35151 25.1023 7.68144C23.4846 7.01138 21.7508 6.6665 19.9998 6.6665Z"
          fill="#F2FBF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_4819_160">
          <rect
            width="39.9219"
            height="39.9219"
            fill="white"
            transform="translate(0.0390625 0.0390625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
